import { serializeError } from '@/store/utils/serialize-error';
import { BrandliveEvent } from '@/types/projects.types';
import { CREATE_FROM_TEMPLATE_IDB_KEY } from '@/utils/create-and-edit-project-helpers/create-from-template.types';
import db from '@/utils/indexed-db';
import { ProjectStateReducerCreator } from '../types';

const updateWorkingProjectWithIndexedDbReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (project: BrandliveEvent | null, { rejectWithValue }) => {
      try {
        if (!project) {
          await db.delete(CREATE_FROM_TEMPLATE_IDB_KEY, CREATE_FROM_TEMPLATE_IDB_KEY);
          return null;
        }

        await db.put({
          uuid: CREATE_FROM_TEMPLATE_IDB_KEY,
          type: CREATE_FROM_TEMPLATE_IDB_KEY,
          data: project,
        });
        return project;
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.workingProject = action.payload || null;
        state.updatingWorkingProject = false;
      },
      pending: (state) => {
        state.updatingWorkingProject = true;
      },
      rejected: (state) => {
        state.updatingWorkingProject = false;
      },
    }
  );
};

export default updateWorkingProjectWithIndexedDbReducer;
